import {Component, OnInit} from '@angular/core';
import {SemanaServices} from '../services/semana.services';
import {TiendaEntity} from '../../CoreModule/entities/tienda.entity';
import {TiendaServices} from '../../CoreModule/services/tienda.services';
import {EmpleadoServices} from '../../CoreModule/services/empleado.services';
import {NgxSpinnerService} from 'ngx-spinner';
import {SemanaModel} from '../models/semana.model';
import {EmpleadoModel} from '../../CoreModule/models/empleado.model';
import {EmpleadoSemanaModel} from '../models/empleado.semana.model';
import {forkJoin} from 'rxjs';

@Component({
  selector: 'inconsistencia-semana',
  templateUrl: '../templates/semanas/inconsistencia.template.html'
})
export class InconsistenciaSemanaComponent implements OnInit {

  public anoSelect: number = 0;
  public semSelect: number = 0;
  public tiendas: TiendaEntity[] = [];

  opcSem: any[] = [];

  rows: any[] = [];
  columns = [
    {name: 'id'},
    {name: 'Nombre'},
    {name: 'Semana'},
    {name: 'pptoTienda'},
    {name: 'pptoEmpleados'},
    {name: 'Acciones'}
  ];
  public tempFullRows: any[] = [];

  constructor(private ss: SemanaServices, private ts: TiendaServices, private es: EmpleadoServices, private spinner: NgxSpinnerService) {
    for (let j = 1; j < 53; j++) {
      this.opcSem.push(j);
    }
  }

  ngOnInit(): void {
    this.spinner.show();
    this.ss.obsSendInconsistencia.subscribe((d:any) => {
      this.rows = [];
      for(let s of d){
        if ((Math.abs(s.ppto - s.pptoEmple)) > 1) {

          this.rows.push({
            id: s.idDB,
            nombre: s.tienda,
            pptoTienda: s.ppto,
            pptoEmpleados: s.pptoEmple,
            acciones: s.id
          });
        }
      }
      this.rows = [...this.rows];
      this.spinner.hide();


    });
    this.ts.getAllTiendas().subscribe(d => {
      this.tiendas = d.data.tiendas;
      this.tiendas = this.tiendas.filter(t => t.activo);
      this.spinner.hide();
    });
  }

  consultarSemanav2() {
    if (this.anoSelect == null) {
      alert('No se ha seleccionado un año valido');
      return;
    }

    if (this.semSelect == null) {
      alert('No se ha seleccionado una semana valida');
      return;
    }

    this.spinner.show();
    this.ss.devolverInconsistenciaSemana(this.semSelect, this.anoSelect);
  }

  consultarSemana() {
    if (this.anoSelect == null) {
      alert('No se ha seleccionado un año valido');
      return;
    }

    if (this.semSelect == null) {
      alert('No se ha seleccionado una semana valida');
      return;
    }

    this.spinner.show();

    this.ss.devolverInfoSemana(`${this.anoSelect}-${this.semSelect}`).subscribe(d => {
      this.rows = [];
      this.tempFullRows = [];

      this.rows = [...this.rows];


      let semanas = d.data.semanas;
      // let ventas = d.data.ventas;


      for (let t of this.tiendas) {
        let foundSem = semanas.find(s => s.tienda == t.idDB);

        let hor = undefined;
        let presupuesto = undefined;


        // this.rows.push({
        //   id:t.idDB,
        //   nombre: t.nombre,
        //   semana: (foundSem != undefined),
        //   presupuesto: (presupuesto != undefined),
        //   horarioTiendas: (t.horario != null && t.horario != "")?"Si":"No",
        //   mallaHorarioEmpleado: (hor != undefined)?"Si":"No",
        //   acciones: (presupuesto != undefined) ? t.id : undefined
        //   // acciones: t.id
        // });

        if (foundSem) {

          this.consultarpptoEmpleados(t, foundSem, this.anoSelect, this.semSelect);
          // if (foundSem.estado.presupuesto != 0) {
          //   this.rows.push({
          //     id: t.idDB,
          //     nombre: t.nombre,
          //     pptoTienda: foundSem.ventasSem,
          //     pptoEmpleados: 0,
          //     acciones: t.id
          //   })
          // }
        }

      }

      this.spinner.hide();
    });
  }

  consultarpptoEmpleados(tienda: TiendaEntity, semana: SemanaModel, ano: any, sem: any) {
    if (semana.estado.presupuesto != 0 && semana.estado.horario != 0) {

      this.ss.devolverVentasEmpleado(ano, sem - 1, tienda.idDB).subscribe(d2 => {

        let ventas = d2.data.ventas;


        if (ventas.length > 0) {

          let idsEmple: string[] = [];

          for (let e of ventas) {
            let found = idsEmple.find(i => i == e.vendedor);
            if (found == undefined)
              idsEmple.push(e.vendedor);
          }

          // devuelve a los empleados por las ventas
          if (semana.estado.finalizada == 1) {

            // this.es.devolverEmpleados(idsEmple).subscribe(d => {
            this.es.devolverEmpleadosSemTienda(semana.semana, semana.tienda).subscribe(d => {
              let consultas: any[] = [];
              for (let e of d.data.devolverEmpleadosSemTienda) {
                let emple = new EmpleadoModel();
                emple.agregarDatos(e, semana);


                consultas.push(this.es.devolverSemanaEmpleadoTienda(emple.id, semana.semana, semana.tienda));
              }

              // console.log(`consultando semanas ${consultas.length}`);
              forkJoin(consultas).subscribe((d: any) => {
                let pptoEmple = 0;
                console.log(d);
                for (let es of d) {
                  let empleSem = EmpleadoSemanaModel.CrearEmpleadoSemana(es.data.empleadoSemanaTienda);

                  if (empleSem != null) {
                    pptoEmple += empleSem.metaTotal;
                  }
                }

                if ((Math.abs(semana.ventasSem - pptoEmple)) > 1) {

                  this.rows.push({
                    id: tienda.idDB,
                    nombre: tienda.nombre,
                    pptoTienda: semana.ventasSem,
                    pptoEmpleados: pptoEmple,
                    acciones: tienda.id
                  });

                  this.rows = [...this.rows];
                }


              });


            });
          } else {
            this.es.devolverEmpleadoTienda(tienda.idDB).subscribe(d => {
              let consultas: any[] = [];
              for (let e of d.data.empleadoTienda) {
                let emple = new EmpleadoModel();
                emple.agregarDatos(e, semana);


                consultas.push(this.es.devolverSemanaEmpleadoTienda(emple.id, semana.semana, semana.tienda));
              }

              // console.log(`consultando semanas ${consultas.length}`);
              forkJoin(consultas).subscribe((d: any) => {
                let pptoEmple = 0;
                console.log(d);
                for (let es of d) {
                  let empleSem = EmpleadoSemanaModel.CrearEmpleadoSemana(es.data.empleadoSemanaTienda);

                  if (empleSem != null) {
                    pptoEmple += empleSem.metaTotal;
                  }
                }

                if ((Math.abs(semana.ventasSem - pptoEmple)) > 1) {

                  this.rows.push({
                    id: tienda.idDB,
                    nombre: tienda.nombre,
                    pptoTienda: semana.ventasSem,
                    pptoEmpleados: pptoEmple,
                    acciones: tienda.id
                  });

                  this.rows = [...this.rows];
                }


              });


            });
          }
        }
      });


    }
  }

}
